<template>
  <a :href="url" class="home-facebook" target="_blank">
    <font-awesome-icon icon="fa-brands fa-facebook" />
    <p>
      Masz pytanie? Zadaj je na grupie Izolacje ROCKWOOL!
    </p>
  </a>
</template>
<script>
import { defineComponent } from 'vue'
import { facebookUrlGroup } from '@/constant/facebook'

export default defineComponent({
  name: 'HomeFacebook',
  data () {
    return {
      url: facebookUrlGroup
    }
  }
})
</script>
<style lang="scss" scoped>
@import "@/styles/global/_variables.scss";
.home-facebook{
  display: flex;
  align-items: center;
  color: #000;
  width: 100%;
  margin-top: 30px;
  @media screen and (max-width: $breakpoint){
    padding: 0 10px;
  }
  svg{
    width: 36px;
    height: 36px;
    margin-right: 12px;
  }
  p{
    font-size: 20px;
    line-height: 28px;
  }
}
</style>